// utils/filterStorage.ts (新設または既存の共通関数ファイルへ)
import dayjs from "dayjs";
import { ListingCategoryConst, PrefTypeConst } from '../constants'; // 合体セレクトボックス用の定数

const STORAGE_KEYS = {
  CATEGORY: "bidding_last_category",
  PREFECTURE: "bidding_last_prefecture",
  DATE: "bidding_filter_date"
};

export const saveFilterPreference = (category?: number, prefecture?: number) => {
  // 値が undefined の場合（「すべて」などが選ばれた場合）は記憶をリセット
  if (category == null || prefecture == null) {
    localStorage.removeItem(STORAGE_KEYS.CATEGORY);
    localStorage.removeItem(STORAGE_KEYS.PREFECTURE);
    localStorage.removeItem(STORAGE_KEYS.DATE);
    return;
  }

  const today = dayjs().format("YYYYMMDD");
  localStorage.setItem(STORAGE_KEYS.CATEGORY, String(category));
  localStorage.setItem(STORAGE_KEYS.PREFECTURE, String(prefecture));
  localStorage.setItem(STORAGE_KEYS.DATE, today); 
};

export const getFilterPreference = () => {
  const savedDate = localStorage.getItem(STORAGE_KEYS.DATE);
  const today = dayjs().format("YYYYMMDD");

  // 保存された日付が今日と一致する場合のみ値を返す
  if (savedDate === today) {
    const category = localStorage.getItem(STORAGE_KEYS.CATEGORY);
    const prefecture = localStorage.getItem(STORAGE_KEYS.PREFECTURE);
    return {
      category: category ? Number(category) : ListingCategoryConst.BIDDING,
      prefecture: prefecture ? Number(prefecture) : PrefTypeConst.INTERNAL,
    };
  }

  // 日付が違う（翌日になった）場合はクリアして初期値(通常県内)を返す
  localStorage.removeItem(STORAGE_KEYS.CATEGORY);
  localStorage.removeItem(STORAGE_KEYS.PREFECTURE);
  localStorage.removeItem(STORAGE_KEYS.DATE);
return {
    category: ListingCategoryConst.BIDDING,
    prefecture: PrefTypeConst.INTERNAL,
};
};